import $ from 'jquery';
import _ from 'lodash';

import BasePropertyTableView from 'BasePropertyTableView.js';
import Immutable from 'immutable';
import contentTemplate from 'properties/table/column-style-border-simple.ejs';
import { pickerCfg } from 'pickerCfg.js';
import util  from 'util/Util.js';

class StyleBorderSimpleView extends BasePropertyTableView {

    initialize( opts ) {
        this.options = opts || {};
        this.template = contentTemplate;
        this.tagName = 'div';
        this.id = opts.el;
        this.colId = this.model.get('selectedRowId');
        this.factoryKey = this.model.get('gridData')[this.colId].attributes['factoryKey'];

        this.events = {
            'blur input[type=text]'   : 'lostFocus',
            'focus input[type=text]'   : 'getFocus',
            'change #borderColor' : 'updateColorAttributesWithValidation',
            'change input[type=color]': 'updateColorAttributes',
            'change #cornerRadius' : 'updateAttributes'
        }

        return this;
    }

    updateForm() {
        //set selected index to model value
        this.setSelectedIndexToModelValue();
    }

    setSelectedIndexToModelValue() {
        if(this.model.get('gridData')[this.colId].attributes['cornerRadius']) {
            $('#cornerRadius').find('option[value='+this.model.get('gridData')[this.colId].attributes['cornerRadius']+']').attr('selected', true);
        }
    }

    render() {
        super.render();

        this.$el.html(this.template(this.model.toJSON()));

        var self = this;

        if (this.factoryKey === 'buttonColumn' ||
            this.factoryKey === 'childFormColumn') {
            $('#prop-column-border-radius').removeClass('hide');
            $('#propStyleBorder .prop-label').removeClass('hide');
        }

        //.$('input[type=color]', this.$el).spectrum(pickerCfg);

        //set selected index to model value
        this.setSelectedIndexToModelValue();

        this.delegateEvents();

        return this;
    }
}

export default StyleBorderSimpleView;